// extracted by mini-css-extract-plugin
module.exports = {"btnAction":"button-edit_btnAction__dSe0K"};